var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCopy = function SvgCopy(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#405261",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M10 12.935V7.242c0-.284-.112-.555-.312-.755L8.179 4.978c-.2-.2-.472-.313-.755-.313H3.731c-.59 0-1.067.478-1.067 1.067v7.203c0 .59.478 1.067 1.067 1.067h5.202c.59 0 1.068-.477 1.068-1.067",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#405261",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M10 11.335h2.267c.59 0 1.067-.478 1.067-1.067V4.574c0-.283-.112-.555-.312-.755L11.513 2.31c-.2-.2-.472-.312-.755-.312H7.065c-.59 0-1.067.477-1.067 1.067v1.6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#405261",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M13.334 4.665H11.2a.533.533 0 0 1-.534-.533V1.998M10 7.333H7.866a.533.533 0 0 1-.534-.533V4.665"
  })));
};
export { SvgCopy as ReactComponent };
export default "data:image/svg+xml;base64,ZXhwb3J0IGRlZmF1bHQgX193ZWJwYWNrX3B1YmxpY19wYXRoX18gKyAiZTRhMGM3ZDM3MWU2MzVhOGJjZDJlOTZkZTFkY2M2MmQuc3ZnIjs=";